import CentumInput from 'components/MainPage/dcs/centumvp/components/Input/CentumInput';
import CentumSelect from 'components/MainPage/dcs/centumvp/components/Select/CentumSelect';
import React, { useState } from 'react';
import { tabComponents } from '../SearchCondition';

interface IUser {}

function UserComponent(props: tabComponents) {
    const [selectedValue, setSelectedValue] = useState<string | number>('');

    // const blockOpt = ['1', '2', '3', '4'];
    const blockOpt = props.tempConfig.user.specifyUser.users;
    const displayEnabled = props.tempConfig.display.search;
    const user = props.tempConfig.user;

    const SelectType = (mode: string) => {
        const updateConf = { ...props.tempConfig };
        updateConf.user.select(mode);
        props.SaveConfig(updateConf);
    };

    const handleSelectChange = (value: string | number, index: number) => {
        const updateConf = { ...props.tempConfig };
        updateConf.user.specifyUser.data[index] = value.toString();
        props.SaveConfig(updateConf);
    };

    return (
        <div
            style={{
                boxSizing: 'border-box',
                width: '100%',
                padding: '20px',
                fontSize: '12px',
                color: displayEnabled ? 'black' : '#808080',
                pointerEvents: displayEnabled ? 'auto' : 'none'
            }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <CentumInput
                    enable={!displayEnabled}
                    checked={user.all}
                    type="radio"
                    id="all"
                    onChange={() => SelectType('all')}
                />
                <span>All</span>
            </div>
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CentumInput
                        enable={!displayEnabled}
                        checked={user.specifyUser.state}
                        type="radio"
                        id="SpecifyUser"
                        onChange={() => SelectType('specifyUser')}
                    />
                    <span>Specify User</span>
                </div>
                <div style={{ display: 'flex', padding: '5px 30px' }}>
                    {user.specifyUser.data.map((num, index) => (
                        <div key={index} style={{ padding: '5px' }}>
                            <CentumSelect
                                disabled={!user.specifyUser.state || !displayEnabled}
                                value={num}
                                options={blockOpt}
                                onChange={(value) => handleSelectChange(value, index)}
                                width={130}
                                height={20}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default UserComponent;
